<template>
 <div class="panel panel-grid-item" :class="{'bg-slate-300': editable , 'bg-white': !editable}">
    <!-- Iconos acciones -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <div
      :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
      @click="onClickEliminar()"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-up': !collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(true)"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-down': collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(false)"
    ></div>
    <!-- //Iconos acciones -->
    <!-- Modo editando -->
    <div class="pt-2 bg-slate-300" style="height: 100%;" v-if="editable && !collapsed">
      <span class="pt-2" :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }">Analisis Tienda</span>
    </div>
    <!-- Modo editando -->
    
    <div class="pt-2" v-if="!editable && !collapsed">
      <span class="titulo-colapsado">Analisis Tienda</span>
    </div>
    <!-- Modo colapsado -->
    <div
      v-else
      class="pt-2"
      :class="{'pointer' : !editable}"
      @click="!editable ? cambiarCollapsed(false) : null"
    >
      <span
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >Analisis Tienda</span>
    </div>
    <!-- //Modo colapsado -->
    <div v-if="!editable && !collapsed" class="mt-2">
      <b-row>
        <b-col  cols="12" sm="12">
          <v-select
            v-model="vcomboTiempo"
            :items="comboTiempo"
            item-value="id"
            item-text="name"
            value="Hoy"
            hide-details
            solo
            attach
            @change="actualizarTabla()"
          ></v-select>
        </b-col>
        <b-col  cols="12" sm="12" class="columna-content mt-2">
          <div>
            <v-data-table
              :headers="headers"
              :items="datosTabla"
              :sort-by="['id.ps0003_tienda']"
              item-key="id.ps0003_tienda"
              hide-actions
              :items-per-page= "100000"
              :mobile-breakpoint = "365"
              :loading = cargando
              class="elevation-5"
              style="overflow: auto; width: 100%;"
              :footer-props="{itemsPerPageText: 'Rows count'}"
            >
            <template v-slot:items="props">
              <tr>
                <td class="text-center">{{ props.item.id.ps0003_tienda }}</td>
                <td class="text-xs-right">{{ props.item.ps0003_Unidades }}</td>
                <td class="text-xs-right">{{ formatNum(props.item.ps0003_Valor) }}€</td>
                <td class="text-xs-right">{{ formatNum(props.item.ps0003_Beneficio) }}€</td>
                <td class="text-center">{{ props.item.ps0003_ROI }}</td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr class="totales">
                  <td class="text-center">TOTAL</td>
                  <td class="text-right">{{totalUnidades}}</td>
                  <td class="text-right">{{totalValor}}€</td>
                  <td class="text-right">{{totalBeneficio}}€</td>
                  <td class="text-center">{{totalRoi}}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true">
                No hay datos
              </v-alert>
            </template>
           </v-data-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { PsApiService } from '@/api/PsApiService'
import { Util } from '@/api/Util'

const psApiService = new PsApiService()
const util = new Util()

export default {
  props: {
    data: Object,
    config: Object,
    editable: Boolean,
    collapsed: Boolean,
    altura: Number,
    id: Number,
    refrescar: Number
  },
  data () {
    return {
      vcomboTiempo: 1,
      comboTiempo: [
        {
          id: 1,
          name: 'Ayer'
        },
        {
          id: 2,
          name: 'Hoy'
        },
        {
          id: 3,
          name: 'Semana'
        },
        {
          id: 4,
          name: 'Mes'
        },
        {
          id: 5,
          name: 'Año'
        }
      ],
      datosTabla: [],
      headers: [
        {
          text: 'Tienda',
          align: 'center',
          sortable: true,
          value: 'id.ps0003_tienda'
        },
        { text: 'Unidades', sortable: true, value: 'ps0003_Unidades', align: 'right' },
        { text: 'Valor', sortable: true, value: 'ps0003_Valor', align: 'right' },
        { text: 'Beneficio', sortable: true, value: 'ps0003_Beneficio', align: 'right' },
        { text: '% ROI', sortable: false, value: 'ps0003_ROI', align: 'center' }
      ],
      vcomboTipoTienda: '--',
      comboTipoTienda: [],
      cargando: false
    }
  },
  computed: {
    regenerar () {
      return this.$store.getters.isRegenerarTablas
    },
    totalUnidades () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0003_Unidades).reduce((prev, next) => prev + next)
        return sum
      } else {
        return 0
      }
    },
    totalValor () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0003_Valor).reduce((prev, next) => prev + next)
        sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 })
        return sum
      } else {
        return 0
      }
    },
    totalBeneficio () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0003_Beneficio).reduce((prev, next) => prev + next)
        sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 })
        return sum
      } else {
        return 0
      }
    },
    totalRoi () {
      if (this.datosTabla.length) {
        let sum, sum2, porcentaje
        sum = this.datosTabla.map(item => item.ps0003_ValorVentaSinIVA).reduce((prev, next) => prev + next)
        sum2 = this.datosTabla.map(item => item.ps0003_Costo).reduce((prev, next) => prev + next)
        porcentaje = Math.round(((sum - sum2) / sum) * 100)
        // porcentaje = ((sum2 / sum) * 100).toFixed(2)
        return porcentaje
      } else {
        return 0
      }
    }
  },
  watch: {
    regenerar (value) {
      console.log(`My store value for 'regenerar' changed to ${value}`)
      this.actualizarTabla()
    },
    refrescar (value) {
      this.actualizarTabla()
    }
  },
  methods: {
    onClickEliminar() {
      if (this.id != undefined) {
        this.$emit("eliminaranalisistienda", this.id);
      }
    },
    cambiarCollapsed(value) {
      let collapseOptions = {};
      collapseOptions.collapse = value;
      collapseOptions.id = this.id;
      collapseOptions.tipo = this.config.tipo;
      collapseOptions.altura = this.altura;
      this.$emit("collapse", collapseOptions);
    },
    formatNum (numero) {
      if (numero !== undefined) {
        return numero.toLocaleString(undefined, { minimumFractionDigits: 0 })
      } else {
        return null
      }
    },
    actualizarTabla () {
      this.cargando = true
      psApiService
        .getAnalisisTienda(this.vcomboTiempo, this.vcomboTipoTienda)
        .then(data => {
          this.datosTabla = data
          util.mostrarEnConsola(
            'getAnalisisTienda',
            data.length,
            'OK'
          )
          this.cargando = false
        })
        .catch(error => {
          util.mostrarEnConsola(
            'getAnalisisTienda',
            error,
            'ERROR'
          )
          this.datosTabla = []
          this.cargando = false
        })
    },
    getAllTipoTiendaAnalisis () {
      this.comboTipoTienda = []
      this.comboTipoTienda.push({ id: '--', name: 'Todas' })
      psApiService
        .getAllTipoTiendaAnalisis()
        .then(data => {
          for (var i = 0; i < data.length; i++) {
            this.comboTipoTienda.push(data[i])
          }
          util.mostrarEnConsola(
            'getAllTipoTiendaAnalisis',
            data.length,
            'OK'
          )
          this.vcomboTipoTienda = '--'
          this.actualizarTabla()
        })
        .catch(error => {
          util.mostrarEnConsola('getAllTipoTiendaAnalisis', error, 'ERROR')
          this.vcomboTipoTienda = '--'
          this.actualizarTabla()
        })
    },
    cambioTitulo() {
      this.$store.state.tituloIcono = '<i class="icon-user-tie"></i>'
      this.$store.state.titulo = 'Analisis tienda'
    }
  },
  created () {
    this.getAllTipoTiendaAnalisis()
    this.cambioTitulo()
  }
}
</script>
